import styled, { css } from 'styled-components';

import { Button as YogaButton } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

import BaseSpinner from 'components/Spinner';

import { ButtonSizeProp, AvailableButtonSizes } from './types';

const baseButtonStyles = (customSize: AvailableButtonSizes) => css`
  ${() => {
    if (customSize === 'md') {
      return 'min-width: 164px;';
    }
    if (customSize === 'sm') {
      return 'min-width: 92px;';
    }
    return 'min-width: unset;';
  }};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;

  &:active,
  &:not([disabled]):hover,
  &:not([disabled]):focus {
    background-color: ${({ theme }) => theme.yoga.colors.primary};
    box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
  }

  ${media.md`
    width: auto;
  `};
`;

export const Button = styled(YogaButton)<ButtonSizeProp>`
  ${baseButtonStyles}

  border: none;
`;

export const OutlineButton = styled(YogaButton.Outline)<ButtonSizeProp>`
  ${baseButtonStyles}

  background-color: ${({ theme }) => theme.yoga.colors.white};
  border: ${({ theme }) => theme.yoga.borders.medium}px solid
    ${({ theme }) => theme.yoga.colors.primary};
  line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
  height: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  padding: ${({ theme }) => theme.yoga.spacing.small}px;
  color: ${({ theme }) => theme.yoga.colors.primary};

  &:not([disabled]):active {
    border: ${({ theme }) => theme.yoga.borders.medium}px solid
      ${({ theme }) => theme.yoga.colors.primary};
    color: ${({ theme }) => theme.yoga.colors.primary};
  }
`;

export const Spinner = styled(BaseSpinner)`
  margin-right: unset !important;

  & .path {
    stroke: ${props => props.theme.yoga.colors.medium} !important;
  }
`;
